export default "__VITE_ASSET__Ce3rZM8z__"